import React, { useState } from 'react'
import { useEffect } from 'react';
import { useRef } from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { Form, Input, CheckboxGroup, Checkbox, Radio, RadioGroup } from 'rsuite';
import TextArea from '../../../Shared/GenericComponents/TextArea';
import CustomAccordionToggle from '../Shared/CustomAccordionToggle';
import PeEiAdditionalInformationSection from './PeEiAdditionalInformationSection';
import PlsLsiAdditionalInformationSection from './PlsLsiAdditionalInformationSection';
import TranscriptsSection from './TranscriptsSection';

function GenericSection(props) {

    const inputRef = useRef(null);

    const [localIsComplete, setLocalIsComplete] = useState(props.isComplete);
    const [isClosed, setIsClosed] = useState(props.isComplete);

    useEffect(() => {
        if (props.collapseSections && inputRef.current && !isClosed)
            inputRef.current.click()
    }, [props.collapseSections])

    useEffect(() => {
        if (props.expandSections && inputRef.current && isClosed)
            inputRef.current.click()
    }, [props.expandSections])

    return (
        <Accordion defaultActiveKey={localIsComplete ? "" : "1"} className="mb-2">
            <Card>
                <Card.Header>
                    <CustomAccordionToggle inputRef={inputRef} eventKey="1" callback={setIsClosed}>
                        <Col>
                            <h5>
                                {props.title}
                            </h5>
                        </Col>
                        <Col style={{ textAlign: "end" }}>
                            <label className="switch" style={{ margin: "0" }}>
                                <input disabled={!props.isUserEditable} name="isComplete" checked={localIsComplete} onChange={() => { props.isCompleteCallback(!localIsComplete); setLocalIsComplete(!localIsComplete); }} type="checkbox" />
                                <span className="slider round"></span>
                            </label>
                        </Col>
                    </CustomAccordionToggle>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                    <Card.Body>
                        {(() => {
                            switch (props.sectionTypeId) {
                                case 17://Years Verified
                                case 18:
                                case 9:
                                    return <>
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Yes</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.ControlLabel>
                                                        <strong>
                                                            Years Verified:
                                                        </strong>
                                                    </Form.ControlLabel>
                                                    <Form.Control type="number" name="verifiedExperienceYears" />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.ControlLabel>
                                                        <strong>
                                                            Months Verified:
                                                        </strong>
                                                    </Form.ControlLabel>
                                                    <Form.Control type="number" name="verifiedExperienceMonths" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>;
                                case 28://MS Degree
                                    return (
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Control name="isMSABET" inline accepter={RadioGroup}>
                                                        <Radio value={true}>ABET BS</Radio>
                                                        <Radio value={false}>NON-ABET BS</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    );
                                case 3://Transcirpts
                                    return <TranscriptsSection entityId={props.entityId} isClosed={isClosed} isUserEditable={props.isUserEditable} />
                                case 10://Violations
                                    return <>
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.ControlLabel>Reviewed:</Form.ControlLabel>
                                                    <Form.Control name="violations" accepter={CheckboxGroup} inline>
                                                        <Checkbox value="App">
                                                            App
                                                        </Checkbox>
                                                        <Checkbox value="NCEES">
                                                            NCEES
                                                        </Checkbox>
                                                        <Checkbox value="CAVU">
                                                            CAVU
                                                        </Checkbox>
                                                        <Checkbox value="FA">
                                                            FA
                                                        </Checkbox>
                                                    </Form.Control>

                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.ControlLabel>Has Violations:</Form.ControlLabel>
                                                    <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Yes</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row></>;
                                case 16://Passed Pe Exam

                                    return <>
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Yes</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <PeEiAdditionalInformationSection />
                                    </>;
                                case 40://Passed Examination
                                    return (props.summaryTypeId == 9) ?
                                        <>
                                            <Row className="mb-3">
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                            <Radio value={true}>Yes</Radio>
                                                            <Radio value={false}>No</Radio>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <PeEiAdditionalInformationSection /> </> : <>
                                            <Row className="mb-3">
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                            <Radio value={true}>Yes</Radio>
                                                            <Radio value={false}>No</Radio>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row><PlsLsiAdditionalInformationSection /></>;
                                case 20://Verification Of Certification
                                    return (props.summaryTypeId == 2 || props.summaryTypeId == 5 || props.summaryTypeId == 7) ?
                                        <>
                                            <Row className="mb-3">
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                            <Radio value={true}>Yes</Radio>
                                                            <Radio value={false}>No</Radio>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row> <PeEiAdditionalInformationSection /></> :
                                        <>
                                            <Row className="mb-3">
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                            <Radio value={true}>Yes</Radio>
                                                            <Radio value={false}>No</Radio>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <PlsLsiAdditionalInformationSection /></>;
                                case 6://Ncees PS Exam
                                    return <>
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Yes</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <PlsLsiAdditionalInformationSection />
                                    </>;
                                case 11://Verified Firm
                                    return (
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Control name="firmLicensure" accepter={CheckboxGroup} inline>
                                                        <Checkbox value="ActiveWithLapels">
                                                            Active w/ LAPELS
                                                        </Checkbox>
                                                        <Checkbox value="NotWithLapels">
                                                            Not Licensed w/ LAPELS
                                                        </Checkbox>
                                                        <Checkbox value="SoleProprietor">
                                                            Sole Proprietor
                                                        </Checkbox>
                                                        <Checkbox value="SeekingEmployment">
                                                            Seeking Employment
                                                        </Checkbox>
                                                    </Form.Control>

                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    );
                                case 12://Quizzes
                                case 13:
                                case 14:
                                    return (
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Passed</Radio>
                                                        <Radio value={false}>Failed</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    );
                                case 23://Surveyor Course Eval Form
                                case 4://NCEES FS
                                case 5://Certified LSI
                                case 24:
                                case 41:
                                case 26:
                                case 27:
                                    return (
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Yes</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    );
                                case 8:
                                    return (props.summaryTypeId == 8) && <Row className="mb-3">
                                        <Col>
                                            <Form.Group>
                                                <Form.Control name="isSectionTrue" inline accepter={RadioGroup}>
                                                    <Radio value={true}>Yes</Radio>
                                                    <Radio value={false}>No</Radio>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>;
                                case 21://Verification of Licensure
                                    return <><Row className="mb-3">
                                        <Col>
                                            <Form.Group>
                                                <Form.Control name="isLicensureActive" inline accepter={RadioGroup}>
                                                    <Radio value={true}>Active</Radio>
                                                    <Radio value={false}>Inactive</Radio>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                        {
                                            (props.summaryTypeId == 8 && props.parentTypeId == 1 && (props.appTypeId == 3 || props.appTypeId == 4))
                                            && <PeEiAdditionalInformationSection />
                                        }
                                        {
                                            (props.summaryTypeId == 8 && props.parentTypeId == 1 && (props.appTypeId == 5 || props.appTypeId == 6))
                                            && <PlsLsiAdditionalInformationSection />
                                        }
                                    </>;
                                case 42:// CPD
                                    return (
                                        <Row className="mb-3">
                                            <Col>
                                                <Form.Group>
                                                    <Form.ControlLabel>
                                                        <strong>
                                                            Has At Least 30 Hrs:
                                                        </strong>
                                                    </Form.ControlLabel>
                                                    <Form.Control name="isAtLeastThirtyHrs" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Yes</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.ControlLabel>
                                                        <strong>
                                                            Two Hours of Ethics:
                                                        </strong>
                                                    </Form.ControlLabel>
                                                    <Form.Control name="isTwoHrEthics" inline accepter={RadioGroup}>
                                                        <Radio value={true}>Yes</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    );
                                default:
                            }

                        })()}

                        <Row className="mb-3">
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel>
                                        <strong>
                                            Date Received:
                                        </strong>
                                    </Form.ControlLabel>
                                    <Form.Control type="date" name="dateReceived" />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row className="mb-3">
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel>
                                        <strong>
                                            Notes:
                                        </strong>
                                    </Form.ControlLabel>
                                    <Form.Control accepter={TextArea} rows={5} name="notes" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    );
}
export default GenericSection;